import { TYPE_ENUM } from '../input-types';

export const id = 'fulfillmentType';
export const apiKey = 'fulfillmentCategory';
export const type = TYPE_ENUM;

export const fulfillmentType = {
  id,
  apiKey,
  type,
};
